/* ==============================================================================================
 * [ISIN] LOGIN MODALS HANDLING
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var licenseModal = document.querySelector("[data-feature=isinRegisterLicenseModal]");
	var formModal = document.querySelector("[data-feature=isinRegisterFormModal]");
	var successModal = document.querySelector("[data-feature=isinRegisterSuccessModal]");

	if (!licenseModal || !formModal || !successModal) {
		return;
	}

	var licenseAgreeOption = licenseModal.querySelector("[data-input=radioAgree]");
	var licenseDeclineOption = licenseModal.querySelector("[data-input=radioDecline]");
	var licenseContinueButton = licenseModal.querySelector("[data-input=buttonContinue]");
	var formAgreeCheckbox = formModal.querySelector("[data-input=checkAgree]");
	var formContinueButton = formModal.querySelector("[data-input=buttonContinue]");

	/**
	 * @return {void}
	 */
	function updateLicenseOptions() {
		licenseContinueButton.disabled = !licenseAgreeOption.checked;
	}

	/**
	 * @return {void}
	 */
	function updateFormOptions() {
		formContinueButton.disabled = !formAgreeCheckbox.checked && isCaptchaVerified();
	}

	/**
	 * @return {void}
	 */
	function continueFromLicense() {
		if (licenseAgreeOption.checked) {
			Sushi.getPluginInstance("Modal", licenseModal).close();
			Sushi.getPluginInstance("Modal", formModal).toggle();
		}
	}

	/**
	 * TODO: Implement captcha verification
	 *
	 * @return {boolean}
	 */
	function isCaptchaVerified() {
		return true;
	}

	licenseAgreeOption.addEventListener("change", updateLicenseOptions);
	licenseDeclineOption.addEventListener("change", updateLicenseOptions);
	licenseContinueButton.addEventListener("click", continueFromLicense);
	formAgreeCheckbox.addEventListener("change", updateFormOptions);

})(Sushi || (Sushi = {}));
